import ReportBg from "@/assets/img/advisors/palm-reportv4.webp"
import CounterImage from "@/assets/img/live-chat/quiz/counter.webp"
import Ellipse from "@/assets/img/live-chat/quiz/ellipse.svg?react"

interface OnboardingReportLockModalProps {
  isOpen: boolean
  timeLeft: string | null
  title?: string
  subtitle?: string
  onClose: () => void
}

/**
 * "Report in progress" bottom sheet for the onboarding 30‑min lock.
 * Visual style matches PalmReportModal; timer source is independent.
 */
export function OnboardingReportLockModal({
  isOpen,
  timeLeft,
  title = "Your Report’s Almost Here!",
  subtitle = "We’re preparing your personalized reading — just a moment left! In the meantime, chat with our expert advisors for quick, personal insights!",
  onClose,
}: OnboardingReportLockModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-[100] flex items-end justify-center bg-[#3b322e70]">
      <div className="max-h-[90dvh] w-full max-w-app overflow-y-auto rounded-t-[20px] bg-dark-surface">
        <div className="relative pt-8">
          <img
            src={ReportBg}
            alt=""
            className="pointer-events-none absolute left-0 top-0 h-60 w-full object-cover"
          />
          <div className="relative z-[1] mx-auto size-[230px]">
            <div className="absolute inset-0 z-[2] animate-spin [animation-duration:13s] [&_svg]:size-[230px]">
              <Ellipse />
            </div>
            <div className="absolute left-1/2 top-1/2 z-[2] flex size-[220px] -translate-x-1/2 -translate-y-1/2 items-center justify-center">
              <img
                src={CounterImage}
                alt=""
                className="pointer-events-none absolute inset-0 size-full object-cover"
              />
              {timeLeft && (
                <span className="relative z-[3] font-display text-[40px] font-bold text-white">
                  {timeLeft}
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="px-4">
          <p className="mt-2 text-center font-display text-2xl font-medium text-purple-light">
            {title}
          </p>
          <p className="mt-2 text-center font-body text-base text-purple-light/70">
            {subtitle}
          </p>

          <button
            type="button"
            onClick={onClose}
            className="my-4 h-14 w-full rounded-[80px] bg-gradient-to-b from-peach to-purple-accent px-5 font-body text-base font-semibold text-white transition-opacity hover:opacity-80"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  )
}
